import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import AppComponent from '../components/app';

const mapStateToProps = (state) => {
	return Object.assign({}, state.app);
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
	}, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AppComponent);



// WEBPACK FOOTER //
// ./client/containers/app.js